import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
import Time from "react-time-format";
import { Link } from "react-router-dom";
import { rozhanaRowKey, centerRowInScroller } from "../../../util/rozhanaRow";

class TableParaKompanya extends React.Component {
  // See ScroollTableRozhana: same mark, same reason — this is the same report,
  // filtered to پارەدان / مافی.کۆمپانیا.
  scrolledTo = null;

  markActiveRow = (node) => {
    if (!node) return;
    const key = node.dataset.rowKey;
    if (this.scrolledTo === key) return;
    this.scrolledTo = key;
    centerRowInScroller(node, ".tableFixHead");
  };

  render() {
    return (
      <>
        <ProductConsumer>
          {(value) => {
            const {
              d_dataRozhana,
              RT_gotoParadanakan,
              RT_gotoMandub,
              JK_kompanyakan,
              d_activeRow,
              D_markActiveRow
            } = value;
            const wakelRaport = d_dataRozhana.map((user, i) => {
              const rowKey = rozhanaRowKey(user.code, user.jwlla);
              const isActive = !!d_activeRow && d_activeRow === rowKey;
              return (
                <tr
                  key={i}
                  className="fk f4"
                  data-row-key={rowKey}
                  ref={isActive ? this.markActiveRow : null}
                  style={{ backgroundColor: isActive ? "#cdd8ad" : "" }}
                >
                  <td
                    className="fk"
                    style={{ border: "2px solid #f0ad4e", color: "red" }}
                  >
                    {user.zh_wakil}
                  </td>
                  <td className="fk" style={{ border: "2px solid #f0ad4e" }}>
                    {user.note}
                  </td>

                  <td className="fk" style={{ border: "2px solid #f0ad4e" }}>
                    {user.nawewargr}
                  </td>
                  {JK_kompanyakan == true ? (
                    <>
                      <td style={{ border: "2px solid #f0ad4e" }}>
                        <NumberFormat
                          value={user.nrxe_RRR}
                          thousandSeparator={true}
                          displayType="text"
                        />
                      </td>
                      <td style={{ border: "2px solid #f0ad4e" }}>
                        <NumberFormat
                          value={user.Krini_RRR}
                          thousandSeparator={true}
                          displayType="text"
                        />
                      </td>
                    </>
                  ) : null}
                  <td
                    style={{ border: "2px solid #f0ad4e" }}
                    className={`fk ${
                      user.joripara == "دۆلار"
                        ? "dark-green"
                        : user.joripara == "دینار"
                        ? "dark-red"
                        : "dark-blue"
                    }`}
                  >
                    {user.joripara}
                  </td>
                  <td className="fk" style={{ border: "2px solid #f0ad4e" }}>
                    <NumberFormat
                      value={
                        Number.isInteger(Number(user.koywasl))
                          ? Number(user.koywasl)
                          : Number(user.koywasl).toFixed(2)
                      }
                      thousandSeparator={true}
                      displayType="text"
                    />
                  </td>
                  <td
                    className="fk text-danger"
                    style={{ border: "2px solid #f0ad4e" }}
                  >
                    {user.wasl}
                  </td>
                  <td className="fk" style={{ border: "2px solid #f0ad4e" }}>
                    {user.jwlla}
                  </td>
                  <td className="fk" style={{ border: "2px solid #f0ad4e" }}>
                    <Time
                      value={user.barwar}
                      format="YYYY-MM-DD"
                      style={{ color: "black" }}
                    />
                  </td>
                  <td
                    className="fk"
                    style={{
                      border: "2px solid #f0ad4e",
                      cursor: "pointer",
                      backgroundColor: isActive ? "#f0ad4e" : "",
                      fontWeight: isActive ? "bold" : ""
                    }}
                    onClick={(e) => {
                      D_markActiveRow(user.code, user.jwlla);
                      user.jwlla == "پارەدان"
                        ? RT_gotoParadanakan(e, user.code, i)
                        : RT_gotoMandub(e, user.code, i);
                    }}
                  >
                    <Link
                      to={`${
                        user.jwlla == "پارەدان"
                          ? "/Paradan"
                          : user.jwlla == "مافی.کۆمپانیا"
                          ? "/Mandub"
                          : "/raporty-kasakan"
                      }`}
                    >
                      {user.code}
                    </Link>
                  </td>
                </tr>
              );
            });

            return (
              <div className="tableFixHead ">
                <table
                  id="example"
                  className="table  table-bordered text-right table-hover"
                >
                  <thead>
                    <tr
                      className="text-warning f4"
                      style={{ backgroundColor: "#2C3539" }}
                    >
                      <th style={{ border: "2px solid #f0ad4e" }}>کۆد</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>تێبینی</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>
                        ناوی وەرگر
                      </th>
                      {JK_kompanyakan == true ? (
                        <>
                          <th style={{ border: "2px solid #f0ad4e" }}>
                            RR نرخی
                          </th>
                          <th style={{ border: "2px solid #f0ad4e" }}>
                            RRR کرینی
                          </th>
                        </>
                      ) : null}
                      <th style={{ border: "2px solid #f0ad4e" }}>دراو</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>
                        کۆی پسوولە
                      </th>
                      <th style={{ border: "2px solid #f0ad4e" }}>
                        و.کۆمپانیا
                      </th>
                      <th style={{ border: "2px solid #f0ad4e" }}>جوولە</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>بەروار</th>
                      <th style={{ border: "2px solid #f0ad4e" }}>ژمارە</th>
                    </tr>
                  </thead>
                  <tbody>{wakelRaport}</tbody>
                </table>
              </div>
            );
          }}
        </ProductConsumer>
      </>
    );
  }
}
export default TableParaKompanya;
